import React, { useState, useEffect } from "react";
import { message } from "antd";

const PRIMARY_COLOR = "#1677ff";
const BUTTON_STYLE = {
  minWidth: 120,
  minHeight: 40,
  fontWeight: 600,
  borderRadius: 8,
  fontSize: 16,
  marginLeft: 10,
  transition: "all 0.2s",
};

export default function CreateSectionModal({ show, onClose, onSubmit, initialValues = {}, isEdit = false }) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [errors, setErrors] = useState({}); // errors.name, errors.description
  const [globalError, setGlobalError] = useState("");

  useEffect(() => {
    if (show) {
      if (isEdit && initialValues) {
        setName(initialValues.title || initialValues.name || "");
        setDescription(initialValues.description || "");
      } else {
        setName("");
        setDescription("");
      }
      setErrors({});
      setGlobalError("");
    }
  }, [show, isEdit, initialValues]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const err = {};
    if (!name.trim()) {
      err.name = "Section name is required!";
    } else if (name.trim().length > 255) {
      err.name = "Section name must not exceed 255 characters";
    }
    if (description.trim().length > 500) {
      err.description = "Description must not exceed 500 characters";
    }
    setErrors(err);

    if (Object.keys(err).length === 0) {
      onSubmit(
        {
          name: name.trim(),
          description: description.trim(),
        },
        {
          setErrors,
        }
      );
    } else {
      if (isEdit) {
        message.error("Failed to update section");
      } else {
        message.error("Failed to create section");
      }
    }
  };

  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        zIndex: 9999,
        left: 0,
        top: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(44,41,99,0.25)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 16,
          boxShadow: "0 10px 32px #2224",
          width: "90vw",
          maxWidth: 480,
          maxHeight: "95vh",
          overflowY: "auto",
        }}
      >
        <form onSubmit={handleSubmit} autoComplete="off">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              borderBottom: "1px solid #eee",
              padding: "18px 28px",
            }}
          >
            <h5 style={{ margin: 0, fontWeight: 700, flex: 1 }}>{isEdit ? "Edit section" : "Add new section"}</h5>
            <button
              type="button"
              onClick={onClose}
              style={{
                border: "none",
                background: "none",
                fontSize: 26,
                lineHeight: 1,
                cursor: "pointer",
                marginLeft: 16,
              }}
              aria-label="Close"
            >
              &times;
            </button>
          </div>
          <div style={{ padding: "22px 28px 0 28px" }}>
            <div className="mb-3" style={{ marginBottom: 20 }}>
              <label className="form-label" style={{ fontWeight: 500 }}>
                Section name <span style={{ color: "red" }}>*</span>
              </label>
              <input
                className="form-control"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                  setErrors((err) => ({ ...err, name: undefined }));
                  setGlobalError("");
                }}
                placeholder="Enter section name..."
                style={{
                  border: errors.name && errors.name.length ? "1.5px solid #ff4d4f" : "1px solid #ced4da",
                  outline: "none",
                }}
                autoFocus
              />
              {errors.name && <div style={{ color: "#ff4d4f", marginTop: 4, fontSize: 13 }}>{errors.name}</div>}
            </div>
            <div className="mb-3" style={{ marginBottom: 12 }}>
              <label className="form-label" style={{ fontWeight: 500 }}>
                Description (optional)
              </label>
              <textarea
                className="form-control"
                value={description}
                onChange={(e) => {
                  setDescription(e.target.value);
                  setErrors((err) => ({ ...err, description: undefined }));
                  setGlobalError("");
                }}
                placeholder="Enter section description (if any)..."
                style={{
                  border: errors.description && errors.description.length ? "1.5px solid #ff4d4f" : "1px solid #ced4da",
                  outline: "none",
                }}
              />
              {errors.description && (
                <div style={{ color: "#ff4d4f", marginTop: 4, fontSize: 13 }}>{errors.description}</div>
              )}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 12,
              padding: "14px 28px 22px",
              borderTop: "1px solid #eee",
            }}
          >
            <button
              type="button"
              onClick={onClose}
              style={{
                ...BUTTON_STYLE,
                background: "#fff",
                color: PRIMARY_COLOR,
                border: `2px solid ${PRIMARY_COLOR}`,
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              style={{
                ...BUTTON_STYLE,
                background: PRIMARY_COLOR,
                color: "#fff",
                border: `2px solid ${PRIMARY_COLOR}`,
              }}
            >
              {isEdit ? "Save changes" : "Create section"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
